import { render, staticRenderFns } from "./researchCourse.vue?vue&type=template&id=d21f5626&scoped=true&"
import script from "./researchCourse.vue?vue&type=script&lang=js&"
export * from "./researchCourse.vue?vue&type=script&lang=js&"
import style0 from "./researchCourse.vue?vue&type=style&index=0&id=d21f5626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21f5626",
  null
  
)

export default component.exports